// ==============================================================================================
//  APPLICATION AUTHORSHIP & RIGHTS NOTICE
//
//  Developed by: Gareth Morgan
//  Brand & Product: BuildMyChecks.co.uk
//  Ownership: Sole author and rights holder
//
//  ----------------------------------------------------------------------------------------------
//  NOTICE:
//  - This application and its related systems were designed, developed, and built solely
//    by Gareth Morgan.
//  - Gareth Morgan retains full authorship, intellectual property, and creative rights to
//    all Build My Checks branding, technology, source code, architecture, and design.
//  - No ownership, license, or implied rights are granted to any third party unless
//    explicitly agreed in writing by Gareth Morgan.
//  - Gareth Morgan is NOT responsible for future maintenance, updates, security patching,
//    or operational upkeep if this application is deployed, copied, or modified without
//    his written consent.
//  - Gareth Morgan reserves the right to:
//       • Withdraw or disable access to the application or related services
//       • Remove hosted, cloud-based, or linked services under his control
//       • Revoke access to Build My Checks–related assets, code, APIs, or integrations
//
//  © 2025 Gareth Morgan — BuildMyChecks.co.uk
//  Unauthorized use, alteration, copying, or redistribution without written consent
//  is strictly prohibited.
//
//  ----------------------------------------------------------------------------------------------
//  Build My Checks – ASCII Logo Signature
//  (Symbolic representation of BuildMyChecks.co.uk identity)
//
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................:-==++-.........:-:.............................................
// ...................................-*******:.......=*****+-.........................................
// ...................................=*******+:.....+*******=.........................................
// .........................::........+**********************=.........................................
// .......................-+***+-.:-++***********************=:.......:................................
// .....................-+*************************************+-..=+**+-..............................
// .....................:+*************+=-.............-++***************+:............................
// ......................:+********+=:.....................:=*************=............................
// .......................=******+:...........................-+********+-.............................
// ......................-*****+:...............................-+*****+-..............................
// ................:::::+****+-...................................=*****+..............................
// ...............+-......:=+-........+=.*%=......##:.:::.....:::..-*****=.............................
// ..............=*-*@%%%%@*.........-#*:#@=......@%::@@@*...*@@#...-+++++**++=-.......................
// .............:**-*@*..=@%.=#+..*#=-%#:#@=.=#%#+@%::@%%%-.=@%@#-##:..##:+*****:......................
// ..............-+-*@@%%@%+.+@*..#@==%#:#@==@%-:+@%::@#-@#:%#+%#.+@#.*@+-******=......................
// .................*@*..:#@++@*..#@==%#:#@=+@#...@%::@#.+@%%-=%#..%@#%#:+******+......................
// .................*@%##%@#.-%@%%@@==%#:#@=:#@%#%%%::@#.:#@*.=%#...%@%:=****+-:.......................
// ..................::........::.........:....::.....:....:......:-#@--***+:..........................
// ................:++:+@@@@@*.:@#:.....................#%=......:#%#-.+***+:..........................
// .............-+**+:#@*:.:+%+:@#-=+-...:=+=-....-+=-..#%=.:=-..-++-..+***+:..........................
// .............+***=-@%.......:@@#+#@#.+@#-+%#:+@%++@%:#%+*@#::%#--*-:*****+-.........................
// .............-***=:@%.......:@%:.-%%:%@%%%%%+#@=.....#@@@%:..#%@@%-=**+++++*+.......................
// ..............****-+%@*=+%@*:@%:.-%%.*@*-=*=.*@%==%#:#@+=@%=:++-+@*-+--===:+=.......................
// .................::::=***=:..++..:++..-+**=...:+**+:.=+-.:++:-*#*=::-:+***=::-++:...................
// ....................-****+=............................*#......+*****************=..................
// .....................=*****=.......+##+.:+##=....*+.-#-*#.**:..:+************++*=...................
// .....................+******+-....*%..:.%*.:%+..:%*.=%=*%%*..:--***********+:..-+:..................
// ....................+*********=:%=+%*+%-*%+*%-=#-#%*%@=*#:%*:+****+++****+=...=*****-...............
// ...................=**********+--::.::....::...:..::.:.:-::-:=***+:..=+*+:..:+******-...............
// ....................-******++*******+=-:............-=++****+=+***+:...:...=******+-:...............
// ......................-++-....=+***************************+=+-=****+:...-+******-..................
// ................................=**********************++-:....=******=:+********=..................
// ................................=**********************=......:+*****************+:.................
// ................................+*******=......+*******=........-+=.:=+****+-.-+-...................
// ................................:-=+***-........+******=..............=***+.........................
// .................................................--::...............................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
//
// ==============================================================================================

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';
import Navbar from '../../components/Navbar';
import BuildMyChecksSocialLinks from '../../components/BuildMyChecksSocialLinks';
import logo from '../../assets/image/logo_web.png';

export default function Contact() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const sendContactEmail = httpsCallable(functions, 'sendContactEmail');
    
    sendContactEmail({
      name: formData.name,
      email: formData.email,
      company: formData.company,
      phone: formData.phone,
      subject: formData.subject,
      message: formData.message
    })
    .then(() => {
      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        company: '',
        phone: '',
        subject: '',
        message: ''
      });
      
      // Reset form after 5 seconds
      setTimeout(() => {
        setSubmitted(false);
      }, 5000);
    })
    .catch((err) => {
      console.error('Error sending contact form:', err);
      setError(err.message || 'Failed to send message. Please try again or contact support@buildmychecks.co.uk');
    })
    .finally(() => {
      setLoading(false);
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">{t('subscription.contact.title', 'Contact Us')}</h1>
          <p className="text-xl text-gray-600">
            {t('subscription.contact.subtitle', "Have a question? We're here to help. Get in touch with our team.")}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('subscription.contact.getInTouch', 'Get in Touch')}</h2>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary text-white text-xl">
                    📧
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold text-gray-900">{t('subscription.contact.emailLabel', 'Email')}</h3>
                  <p className="text-gray-600 mt-1">
                    <a href="mailto:support@buildmychecks.co.uk" className="text-primary hover:underline">
                      support@buildmychecks.co.uk
                    </a>
                  </p>
                  <p className="text-sm text-gray-500 mt-1">{t('subscription.contact.responseTime', 'We respond within 24 hours on business days')}</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary text-white text-xl">
                    💬
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold text-gray-900">{t('subscription.contact.liveChatLabel', 'Live Chat')}</h3>
                  <p className="text-gray-600 mt-1">
                    {t('subscription.contact.liveChatDesc', 'Contact us via email for fastest response')}
                  </p>
                  <p className="text-sm text-gray-500 mt-1">{t('subscription.contact.responseTime', 'We respond within 24 hours on business days')}</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary text-white text-xl">
                    💼
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold text-gray-900">{t('subscription.contact.businessLabel', 'Business Details')}</h3>
                  <p className="text-gray-600 mt-1">
                    {t('footer.brandName', 'Build My Checks')}<br />
                    {t('subscription.contact.soleTrader', 'Sole Trader Business')}<br />
                    {t('subscription.contact.operatingUK', 'Operating in the United Kingdom')}
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary text-white text-xl">
                    🕐
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold text-gray-900">{t('subscription.contact.supportHoursLabel', 'Support Hours')}</h3>
                  <p className="text-gray-600 mt-1">
                    {t('subscription.contact.supportHoursLine1', 'Email support available 24/7')}<br />
                    {t('subscription.contact.supportHoursLine2', 'Responses within 24 hours')}<br />
                    {t('subscription.contact.supportHoursLine3', 'Monday-Friday business days')}
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-6 bg-blue-50 rounded-lg border-l-4 border-primary">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{t('subscription.contact.salesTitle', 'Sales Inquiries')}</h3>
              <p className="text-gray-700 mb-2">
                {t('subscription.contact.salesDesc', 'Interested in Build My Checks for your organization? Contact our sales team:')}
              </p>
              <p className="text-primary font-semibold">
                <a href="mailto:sales@buildmychecks.co.uk" className="hover:underline">
                  sales@buildmychecks.co.uk
                </a>
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('subscription.contact.sendMessage', 'Send us a Message')}</h2>
            
            {submitted ? (
              <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
                <div className="text-4xl mb-4">✅</div>
                <h3 className="text-xl font-semibold text-green-900 mb-2">{t('subscription.contact.messageSent', 'Message Sent!')}</h3>
                <p className="text-green-700">
                  {t('subscription.contact.thankYou', "Thank you for contacting us. We'll get back to you within 24 hours.")}
                </p>
              </div>
            ) : (
              <>
                {error && (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                    <p className="text-red-700">{error}</p>
                  </div>
                )}
                <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    {t('subscription.contact.fullName', 'Full Name')} *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                    placeholder={t('subscription.contact.namePlaceholder', 'John Smith')}
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    {t('subscription.contact.emailAddress', 'Email Address')} *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                    placeholder={t('subscription.contact.emailPlaceholder', 'john@company.com')}
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                      {t('subscription.contact.companyLabel', 'Company')}
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      placeholder={t('subscription.contact.companyPlaceholder', 'Your Company Ltd')}
                    />
                  </div>

                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                      {t('subscription.contact.phoneLabel', 'Phone Number')}
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      placeholder={t('subscription.contact.phonePlaceholder', '+44 20 1234 5678')}
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                    {t('subscription.contact.subjectLabel', 'Subject')} *
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    required
                    value={formData.subject}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  >
                    <option value="">{t('subscription.contact.selectSubject', 'Select a subject')}</option>
                    <option value="sales">{t('subscription.contact.salesEnquiry', 'Sales Enquiry')}</option>
                    <option value="support">{t('subscription.contact.technicalSupport', 'Technical Support')}</option>
                    <option value="billing">{t('subscription.contact.billingQuestion', 'Billing Question')}</option>
                    <option value="demo">{t('subscription.contact.requestDemo', 'Request a Demo')}</option>
                    <option value="feedback">{t('subscription.contact.feedback', 'Feedback')}</option>
                    <option value="other">{t('subscription.contact.other', 'Other')}</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                    {t('subscription.contact.messageLabel', 'Message')} *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                    placeholder={t('subscription.contact.messagePlaceholder', 'Tell us how we can help...')}
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-primary hover:bg-red-700 disabled:bg-gray-400 text-white px-6 py-3 rounded-lg font-semibold shadow-lg transition-colors"
                >
                  {loading ? t('common.sending', 'Sending...') : t('subscription.contact.sendMessageBtn', 'Send Message')}
                </button>

                <p className="text-sm text-gray-500 text-center">
                  {t('subscription.contact.privacyConsent', 'By submitting this form, you agree to our')} <a href="/privacy" className="text-primary hover:underline">{t('footer.privacyPolicy', 'Privacy Policy')}</a>
                </p>
              </form>
              </>
            )}
          </div>
        </div>

        {/* FAQ Section */}
        <div className="mt-20">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">{t('subscription.contact.faqTitle', 'Frequently Asked Questions')}</h2>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">{t('subscription.contact.faq1Title', 'How quickly do you respond?')}</h3>
              <p className="text-gray-600">
                {t('subscription.contact.faq1Answer', 'We aim to respond to all inquiries within 24 hours during business days (Monday-Friday, 9am-5pm GMT). Urgent issues are typically addressed within a few hours.')}
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">{t('subscription.contact.faq2Title', 'Can I schedule a demo?')}</h3>
              <p className="text-gray-600">
                {t('subscription.contact.faq2Answer', 'Absolutely! Select "Request a Demo" in the contact form above, or email')}
                <a href="mailto:sales@buildmychecks.co.uk" className="text-primary hover:underline ml-1">
                  sales@buildmychecks.co.uk
                </a> {t('subscription.contact.faq2AnswerEnd', 'directly to schedule a personalized demonstration.')}
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">{t('subscription.contact.faq3Title', 'What if I need help outside business hours?')}</h3>
              <p className="text-gray-600">
                {t('subscription.contact.faq3Answer', 'You can still submit a support request via email or the contact form at any time. We\'ll respond as soon as our team is available. For urgent issues, we offer priority support for enterprise customers.')}
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">{t('subscription.contact.faq4Title', 'How do I contact support?')}</h3>
              <p className="text-gray-600">
                {t('subscription.contact.faq4Answer', 'Email is the best way to reach us at support@buildmychecks.co.uk. We respond within 24 hours on business days and can arrange calls if needed for complex issues.')}
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm text-gray-400 mb-2">&copy; 2025 {t('footer.brandName', 'Build My Checks')}. {t('footer.allRightsReserved', 'All rights reserved.')}</p>
          <BuildMyChecksSocialLinks className="flex items-center justify-center gap-3 mt-4" />
        </div>
      </footer>
    </div>
  );
}

// ----------------------------------------------------------------------------------------------
//  Build My Checks (c) 2025 Gareth Morgan - BuildMyChecks.co.uk
//  Solely designed, developed, and maintained by Gareth Morgan.
//  All intellectual property rights reserved.
//  No liability is accepted for unauthorised use, modification, deployment, or maintenance.
// ----------------------------------------------------------------------------------------------
